<div class="pb-3">
    <h1 class="fs-2 fw-light text-gray-600">Dashboard</h1>
</div>
<app-lender-dashboard *ngIf="user.isLender"></app-lender-dashboard>
<app-user-dashboard *ngIf="!user.isLender"></app-user-dashboard>
